<template>
  <section id="devicelist" class="content">
    <!--filter-->
    <!--/ filter-->
    <!--data aggregation-->
    <div class="row" v-show="isAgentAdmin">
      <div class="col-xs-12">
        <div class="box box-warning">
          <div class="row data_aggregation_table_margin">
            <div class="col-xs-6">
              <table class="device-information-table">
                <tbody>
                  <tr>
                    <th
                      class="device-information-table-title table-width-quarter data_aggregation_title_color"
                    >
                      online device
                    </th>
                    <th
                      class="device-information-table-content table-width-quarter data_aggregation_title_color"
                    >
                      {{ onlineDevice }}
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-xs-6">
              <table class="device-information-table">
                <tbody>
                  <tr>
                    <th
                      class="device-information-table-title table-width-quarter data_aggregation_title_color"
                    >
                      total device
                    </th>
                    <th
                      class="device-information-table-content table-width-quarter data_aggregation_title_color"
                    >
                      {{ totalDevice }}
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row data_aggregation_table_margin">
            <div class="col-xs-6">
              <table class="device-information-table">
                <tbody>
                  <tr>
                    <th
                      class="device-information-table-title table-width-quarter"
                    >
                      server
                    </th>
                    <th
                      class="device-information-table-content table-width-quarter"
                    >
                      number of device
                    </th>
                  </tr>
                  <tr>
                    <td
                      class="device-information-table-title table-width-quarter"
                    >
                      api_as
                    </td>
                    <td
                      class="device-information-table-content table-width-quarter"
                    >
                      {{ as }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="device-information-table-title table-width-quarter"
                    >
                      api_eu
                    </td>
                    <td
                      class="device-information-table-content table-width-quarter"
                    >
                      {{ eu }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="device-information-table-title table-width-quarter"
                    >
                      api_us
                    </td>
                    <td
                      class="device-information-table-content table-width-quarter"
                    >
                      {{ us }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-xs-6">
              <table class="device-information-table">
                <tbody>
                  <tr>
                    <th
                      class="device-information-table-title table-width-quarter"
                    >
                      sim card status
                    </th>
                    <th
                      class="device-information-table-content table-width-quarter"
                    >
                      number of device
                    </th>
                  </tr>
                  <tr>
                    <td
                      class="device-information-table-title table-width-quarter"
                    >
                      normal
                    </td>
                    <td
                      class="device-information-table-content table-width-quarter"
                    >
                      {{ normalsim }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="device-information-table-title table-width-quarter"
                    >
                      have no card
                    </td>
                    <td
                      class="device-information-table-content table-width-quarter"
                    >
                      {{ noCard }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="device-information-table-title table-width-quarter"
                    >
                      with problem
                    </td>
                    <td
                      class="device-information-table-content table-width-quarter"
                    >
                      {{ problem }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
    <!--data aggregation-->
    <!--device list-->
    <div class="box box-default device-list-box" v-for="item in devicelist">
      <router-link
        :to="{
          path:
            '/aboutdevice?appname=' +
            $route.query.appname +
            '&appid=' +
            $route.query.appid +
            '&devicename=' +
            encodeURIComponent(item.devicename) +
            '&deviceid=' +
            item.deviceid +
            '&online=' +
            item.online +
            '&t=' +
            item.devicetoken
        }"
        class="device-list-hover"
      >
        <div class="box-header with-border">
          <h3 class="box-title device-list-name">{{ item.devicename }}</h3>
          <span class="agent-list-id device-list-id"
            >( <span>{{ item.deviceid }}</span> )
          </span>

          <div class="pull-right device-list-go-to">
            <span
              >More&nbsp;&nbsp;
              <i class="fa fa-ellipsis-v"></i>
            </span>
          </div>
        </div>

        <div class="box-body">
          <table class="device-list-table">
            <tr class="device-list-row">
              <td class="col-xs-4">
                <span class="device-list-table-content"
                  >country/region:&nbsp;</span
                >
                <span>{{ item.ipaddress }}</span>
              </td>
              <td class="col-xs-4 device-list-middle">
                <span class="device-list-table-content"
                  >network status:&nbsp;</span
                >
                <span v-if="item.online != 1">&nbsp;-</span>
                <span
                  class="device-network-status-excellent"
                  v-else-if="item.network / 1000000 < 200"
                  >excellent&nbsp;
                  <i class="fa fa-thumbs-o-up"></i>
                </span>
                <span
                  class="device-network-status-good"
                  v-else-if="item.network / 1000000 < 400"
                  >good&nbsp;
                  <i class="fa fa-hand-peace-o"></i>
                </span>
                <span class="device-network-status-poor" v-else
                  >poor&nbsp;
                  <i class="fa fa-thumbs-o-down"></i>
                </span>
              </td>
              <td class="col-xs-4 device-list-right">
                <span
                  class="device-list-table-content device-online-status"
                  v-if="item.online == 1"
                >
                  <i class="fa fa-check-circle"></i>&nbsp;online
                </span>
                <span
                  class="device-list-table-content device-offline-status"
                  v-else
                >
                  <i class="fa fa-times-circle"></i>&nbsp;offline
                </span>
              </td>
            </tr>
            <tr class="device-list-row">
              <td class="col-xs-4">
                <span class="device-list-table-content"
                  >firmware version:&nbsp;</span
                >
                <span>{{ item.version }}</span>
              </td>
              <td
                class="col-xs-4 device-list-middle"
                v-if="item.activetime > 0"
              >
                <span class="device-list-table-content"
                  >activation time:&nbsp;</span
                >
                <span>{{ (item.activetime / 1000000) | formatDate }}</span>
              </td>
              <td class="col-xs-4 device-list-middle" v-else>
                <span class="device-list-table-content"
                  >activation time:&nbsp;</span
                >
                <span>&nbsp;-</span>
              </td>
              <td class="col-xs-4 device-list-right" v-show="false">
                <span class="device-list-table-content"
                  >production batch:&nbsp;</span
                >
                <span>1862443</span>
              </td>
            </tr>
          </table>
        </div>
        <!-- /.box-body -->
      </router-link>
    </div>
    <!-- /.box -->
    <!--/ device list-->
  </section>
</template>
<script>
import utils from "../../utils";
import api from "../../api";
import global from "../Global.vue";

export default {
  name: "Device",
  data() {
    return {
      devicelist: [],
      currentDeviceListHeight: 0,
      currentPage: 0,
      isSearchByName: false,
      searchName: "",
      isLoadMore: false,
      totalDevice: "-",
      onlineDevice: "-",
      as: "-",
      eu: "-",
      us: "-",
      normalsim: "-",
      noCard: "-",
      problem: "-",
      isAgentAdmin: utils.checkIsAppAdmin()
    };
  },
  created() {
    this.$bus.on("searchdevice", this.init);
  },
  beforeDestroy() {
    this.$bus.off("searchdevice", this.init);
    this.$bus.emit("showsearchuserkey", { key: "" });
  },
  methods: {
    init(key) {
      this.isLoadMore = false;
      this.currentPage = 0;
      this.currentDeviceListHeight = -1;
      window.scrollTo(0, 0);
      if (utils.isEmpty(key) || utils.isEmpty(key.key)) {
        this.toGetAllDevice(0);
      } else {
        this.toGetAllDeviceByName(key.key, 0);
      }
    },
    toGetAllDevice(page) {
      this.isSearchByName = false;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        page: page
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/getdevicesbyappid?_type=json", params)
        .then(response => {
          var data = response.data;
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              if (!this.isLoadMore) {
                this.devicelist = [];
                this.devicelist = JSON.parse(
                  utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
                );
              } else {
                var tempList = JSON.parse(
                  utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
                );
                this.devicelist = this.devicelist.concat(tempList);
              }
              this.fixQuery();
            }
          }
        });
    },
    toGetAllDeviceByName(key, page) {
      this.isSearchByName = true;
      this.searchName = key;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        page: page,
        deviceid: key
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
      api
        .request("post", "/getdevicesbyappid?_type=json", params)
        .then(response => {
          this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
          var data = response.data;
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              if (!this.isLoadMore) {
                this.devicelist = [];
                this.devicelist = JSON.parse(
                  utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
                );
              } else {
                var tempList = JSON.parse(
                  utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
                );
                this.devicelist = this.devicelist.concat(tempList);
              }
              this.fixQuery();
            }
          }
        });
    },
    winScroll(e) {
      if (
        this.currentDeviceListHeight < window.jQuery("#devicelist").height()
      ) {
        if (
          window.jQuery(window).scrollTop() + window.jQuery(window).height() >=
          window.jQuery("#devicelist").height()
        ) {
          this.currentDeviceListHeight =
            window.jQuery(window).scrollTop() + window.jQuery(window).height();
          this.isLoadMore = true;
          this.getNextPage();
        }
      }
    },
    fixQuery() {
      //        if (this.devicelist.length > 0) {
      //          for (var i = 0; i < this.devicelist.length; i++) {
      //            this.devicelist[i].deviceid = encodeURIComponent(this.devicelist[i].deviceid)
      //            this.devicelist[i].devicename = encodeURIComponent(this.devicelist[i].devicename)
      //          }
      //        }
    },
    getNextPage() {
      this.currentPage = this.currentPage + 1;
      if (!this.isSearchByName) {
        this.toGetAllDevice(this.currentPage);
      } else {
        this.toGetAllDeviceByName(this.searchName, this.currentPage);
      }
    },
    getAggregation() {
      var that = this;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/appaggregation?_type=json", params)
        .then(response => {
          var data = response.data;
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              var result = JSON.parse(
                utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
              );
              //                that.totalDevice = result.totaldevice
              that.totalDevice =
                result.simnormal + result.nocard + result.problem;
              //                that.onlineDevice = result.onlinetotal
              that.onlineDevice = result.as + result.eu + result.us;
              that.as = result.as;
              that.eu = result.eu;
              that.us = result.us;
              that.normalsim = result.simnormal;
              that.noCard = result.nocard;
              that.problem = result.problem;
            }
          }
        });
    }
  },
  mounted() {
    this.init();
    this.getAggregation();
    window.addEventListener("scroll", this.winScroll);
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return utils.formatDate(date, "yyyy-MM-dd");
    },
    encodeURI(url) {
      return encodeURIComponent(url);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// Device.vue?08921b32